import React from 'react';
import PropTypes from 'prop-types';
import PDFViewerModal from '../../../common/PDFViewerModal';

/**
 * ExampleModal - Displays example reports
 *
 * This component now uses the shared PDFViewerModal for consistent PDF viewing
 * across the application.
 */
const ExampleModal = ({ isOpen, pdfUrl, onClose }) => {
  return (
    <PDFViewerModal
      isOpen={isOpen}
      pdfUrl={pdfUrl}
      title="Example Report"
      filename="example-report.pdf"
      onClose={onClose}
    />
  );
};

ExampleModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  pdfUrl: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ExampleModal;
